/*
* PdfImageContent.js
* Created on 22-11-2017
* @author Olivier for &ranj
* 
* Image content that displays the image from a Base64 string, specified in pdf_config.json under "images"
* These strings can be either hard coded into pdf_config.json, or they can be inserted dynamically using the PdfConfig.setImageData method
* 
* For creating a hard coded Base64 string from an image, see https://www.base64-image.de/
* You can also render images from the game canvas through the HTML5 canvas 'toDataURL' method
*/

import { isNull } from "../../../util/TypeUtil";
import AbstractPdfContent from "./AbstractPdfContent";

export default class PdfImageContent extends AbstractPdfContent {
    constructor(pdfConfig, style) {
        super(style);

        this._pdfConfig = pdfConfig;
        this._imageDataKey = null;

        this.setPropertiesFromObject(style);
    }

    setImageDataKey(key) {
        this._imageDataKey = key;
    }

    setPropertiesFromObject(obj) {
        super.setPropertiesFromObject(obj);

        for (let property in obj) {
            if (obj.hasOwnProperty(property)) {
                switch (property) {
                    case ("data"): this._imageDataKey = obj[property]; break;
                }
            }
        }
    }

    calculateBounds(doc) {
        let data = this._pdfConfig.getImageData(this._imageDataKey);

        if (this._width === 0 && this._height > 0) {
            //only height is set, calculate proportionate width
            let ratio = this._height / data.height;
            this.setWidth(data.width * ratio);

        } else if (this._height === 0 && this._width > 0) {
            //only width is set, calculate proportionate height
            let ratio = this._width / data.width;
            this.setHeight(data.height * ratio);

        } else if (this._height === 0 && this._width === 0) {
            //just use the native image size
            this.setWidth(data.width);
            this.setHeight(data.height);
        }
    }

    printToDocument(doc, x, y) {
        const top = y + this._padding[0];
        const left = x + this._padding[3];

        if (isNull(this._imageDataKey)) {
            return;
        }

        const data = this._pdfConfig.getImageData(this._imageDataKey);

        //console.warn("[PdfImageContent] Drawing image " + this._imageDataKey + " at " + x + "," + y + ", size: "+ this._width + ", " + this._height);

        //set encoding to png or jpg based on image data string, default is jpg
        const encoding = data.data.indexOf('image/png') >= 0 ? 'image/png' : 'image/jpeg';

        doc.addImage(data.data, encoding, left, top, this._width, this._height);
    }
}